module.exports = __webpack_public_path__ + "img/logo1 (23).5271d11c.jpg";